export const LEGACY_PERPAY_PLUS = 'perpay_plus';
export const LEGACY_PERPAY_PLUS_V2 = 'perpay_plus_v2';
export const PERPAY_PLUS = 'perpay_plus_v2_five_dollars';
export const PERPAY_PLUS_SOLO = 'perpay_plus_solo';
export const CARD = 'card';
export const CARD_AUTO_APPLY = 'card_auto_apply';

const LEGACY_PERPAY_PLUS_VERSIONS = [LEGACY_PERPAY_PLUS, LEGACY_PERPAY_PLUS_V2];

// Not including Solo
const PERPAY_PLUS_VERSIONS = [...LEGACY_PERPAY_PLUS_VERSIONS, PERPAY_PLUS];

export const ALL_PERPAY_PLUS_VERSIONS = [
    ...PERPAY_PLUS_VERSIONS,
    PERPAY_PLUS_SOLO,
];

export const getIsPerpayPlusVersion = (version) =>
    PERPAY_PLUS_VERSIONS.includes(version);
